import React, { useMemo } from 'react';
import { Box, BoxExtendedProps, ErrorMessage, Inscription } from '@common-fe/common-fe';

import LockboxInfoContainer from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxInfoContainer';
import ContinueInAdminPortal from '../LockboxEmployees/ContinueInAdminPortal';

interface Props {
  testId?: string;
  title: string;
  errorText?: string;
  isErrorTopPosition?: boolean;
  headerChildren?: React.ReactNode;
  children?: React.ReactNode;
  childrenWrapperProps?: BoxExtendedProps;
}

const MatchingListWrapper: React.FC<Props> = ({ testId, title, errorText, isErrorTopPosition, headerChildren, childrenWrapperProps, children }) => {
  const error = useMemo(() => (
    errorText ? (
      <Box margin={{ ...isErrorTopPosition ? { bottom: 'spacing12' } : { left: 'spacing12' } }}>
        <ErrorMessage errorText={errorText} />
      </Box>
    ) : null
  ), [errorText, isErrorTopPosition]);

  return (
    <LockboxInfoContainer data-testid={`${testId}-matching-list-wrapper`} margin={{ top: 'spacing8' }}>
      {isErrorTopPosition ? error : null}
      <Box direction="row" align="center">
        <Inscription color="textSecondary">{title}</Inscription>
        {headerChildren}
        {!isErrorTopPosition ? error : null}
      </Box>
      <Box
        background="module"
        round="container1Round"
        margin={{ top: 'spacing12' }}
        pad={{ vertical: 'spacing16', horizontal: 'spacing24' }}
        {...childrenWrapperProps}
      >
        {children}
      </Box>
      <ContinueInAdminPortal />
    </LockboxInfoContainer>
  );
};
export default MatchingListWrapper;
